import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService, MICROSOFT_LOGIN } from './shared/services/auth.service';
import { Router } from '@angular/router';
import { UserSettings } from './shared/models/user-settings';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UsersService } from 'app/pages/admin/users.service';
import { TermsDialogComponent } from './pages/terms-dialog';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
    /**
     * Creates an instance of AppComonent.
     * @param authService Represents a reference to the Authentication Service.
     */

    constructor(private authService: AuthService, private userService: UsersService, private matDialog: MatDialog, private router: Router) {
        // this is a hack fix to get rid of id_token in the URL
        // hopefully we can figure out why the token is there
        if (window.location.hash.search('id_token=') > 0) {
            window.location.hash = '';
        }

        // set default language
        // this.translate.setDefaultLang('en-us');

        // this.translate.use('en-us');
    }


    ngOnInit() {
    this.authService.gotTheToken$.subscribe(hasToken => {
      if (hasToken && sessionStorage.getItem(MICROSOFT_LOGIN) === '1') {
        this.afterMicrosoftLogin();
      }
    });
  }

    private afterMicrosoftLogin() {
        this.userService.getUserSettings().subscribe((settings: UserSettings) => {
            if (!settings.acceptedTerms) {
                this.matDialog
                    .open(TermsDialogComponent, { disableClose: true })
                    .afterClosed()
                    .subscribe((result) => {
                        if (result && result.success) {
                            this.userService
                                .updateUserSettings({
                                    ...settings,
                                    acceptedTerms: true,
                                })
                                .subscribe(() => { });
                        }
                        else {
                            this.authService.logout();
                        }

                    });
            }
        })
    }


    /**
     * Ensures authentication.
     */
    public get isUserAuthenticated() {
        return this.authService.isAuthenticated;
    }
}
